"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.tooltips.preview': 'Podgląd szczegółów firmy',
};
